/**
 * TypeBadge - Display Pokemon type as a colored badge
 */
import { useApp } from '../../context/AppContext';

// Type colors mapping
const TYPE_COLORS = {
  normal: { bg: 'bg-gray-400', text: 'text-gray-900', border: 'border-gray-500' },
  fire: { bg: 'bg-orange-500', text: 'text-white', border: 'border-orange-600' },
  water: { bg: 'bg-blue-500', text: 'text-white', border: 'border-blue-600' },
  electric: { bg: 'bg-yellow-400', text: 'text-gray-900', border: 'border-yellow-500' },
  grass: { bg: 'bg-green-500', text: 'text-white', border: 'border-green-600' },
  ice: { bg: 'bg-cyan-400', text: 'text-gray-900', border: 'border-cyan-500' },
  fighting: { bg: 'bg-red-700', text: 'text-white', border: 'border-red-800' },
  poison: { bg: 'bg-purple-500', text: 'text-white', border: 'border-purple-600' },
  ground: { bg: 'bg-amber-600', text: 'text-white', border: 'border-amber-700' },
  flying: { bg: 'bg-indigo-400', text: 'text-white', border: 'border-indigo-500' },
  psychic: { bg: 'bg-pink-500', text: 'text-white', border: 'border-pink-600' },
  bug: { bg: 'bg-lime-500', text: 'text-gray-900', border: 'border-lime-600' },
  rock: { bg: 'bg-stone-500', text: 'text-white', border: 'border-stone-600' },
  ghost: { bg: 'bg-violet-600', text: 'text-white', border: 'border-violet-700' },
  dragon: { bg: 'bg-indigo-600', text: 'text-white', border: 'border-indigo-700' },
  dark: { bg: 'bg-gray-700', text: 'text-white', border: 'border-gray-800' },
  steel: { bg: 'bg-slate-400', text: 'text-gray-900', border: 'border-slate-500' },
  fairy: { bg: 'bg-pink-400', text: 'text-gray-900', border: 'border-pink-500' }
};

export function TypeBadge({ type, size = 'sm', showLabel = true, className = '' }) {
  const { t } = useApp();
  const colors = TYPE_COLORS[type] || TYPE_COLORS.normal;
  
  const sizeClasses = {
    xs: 'px-1.5 py-0.5 text-[10px]',
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base'
  };
  
  return (
    <span
      data-testid={`type-badge-${type}`}
      className={`
        inline-flex items-center justify-center
        ${colors.bg} ${colors.text}
        ${sizeClasses[size]}
        rounded-full font-semibold uppercase tracking-wider
        border ${colors.border}
        shadow-sm
        transition-transform hover:scale-105
        ${className}
      `}
    >
      {showLabel ? t(`types.${type}`) || type : type}
    </span>
  );
}

export function TypeBadgeGroup({ types, size = 'sm', className = '' }) {
  return (
    <div className={`flex flex-wrap gap-1.5 ${className}`} data-testid="type-badge-group">
      {types.map(type => (
        <TypeBadge key={type} type={type} size={size} />
      ))}
    </div>
  );
}

export default TypeBadge;
